// extracted by css-extract-rspack-plugin
export default {"root":"root-gGGN70","text":"text-V1IfSG"};